<!-- mettal-3\src\components\Teacher22.vue -->
<template>
  <div :class="[`teacher`, className || ``]">
    <img
      class="vector-138"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-590.svg"
      alt="Vector"
    />
    <img
      class="vector-139"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-591.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "Teacher22",
  props: ["className"],
};
</script>

<style scoped>
.teacher {
  aspect-ratio: 1;
  height: 83.33%;
  left: 0;
  position: absolute;
  top: 0;
  width: 19.84%;
}

.vector-138 {
  height: 32.66%;
  left: 16.16%;
  position: absolute;
  top: 67.34%;
  width: 67.81%;
}

.vector-139 {
  height: 71.25%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.teacher.teacher-3,
.teacher.teacher-4 {
  width: 18.94%;
}
</style>
